import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 12l14 0","key":"svg-0"}]]

const IconMinus = createReactComponent('outline', 'minus', 'Minus', __iconNode);

export default IconMinus;